import { makeAutoObservable } from "mobx"

class AppStore {
  appLoaded = false
  windowHeight = window.innerHeight
  windowWidth = window.innerWidth
  device = 0
  mainFooter = false
  isLocalHost = window.location.href.includes("localhost")
  isResumeJourney = new URL(window.location.href).searchParams.get("applicationState") === "resume"
  visitedQuoteScreen = false //used to load third party lib on quote page
  depTesting = new URL(window.location.href).searchParams.get("depTesting") === "yes"
  appFormLoaded = false // State Updates Only Once To Keep AppForm Mounted Once Its Loaded
  isTesting = window.location.href.includes("testing")
  appFormTest = new URL(window.location.href).searchParams.get("isUAT") === "yes"
  showRemoteHandOverAppForm = false

  constructor() {
    makeAutoObservable(this)
  }
  setAppLoaded = (data) => (this.appLoaded = data)
  setWindowHeight = (data) => (this.windowHeight = data)
  setWindowWidth = (data) => (this.windowWidth = data)
  setDevice = (data) => (this.device = data)
  setmainFooter = (data) => (this.mainFooter = data)
  setLocalHost = (data) => (this.isLocalHost = data)
  setIsResumeJourney = (data) => (this.isResumeJourney = data)
  setVisitedQuoteScreen = (data) => (this.visitedQuoteScreen = data)
  setAppFormLoaded = (data) => (this.appFormLoaded = data)
  setIsTesting = (data) => (this.isTesting = data)
  setShowRemoteHandOverAppForm = (data) => (this.showRemoteHandOverAppForm = data)
}

export default new AppStore()
